import React from "react";
import styles from "./controlGroups.module.scss";
import { DataGrid } from "@mui/x-data-grid";
import clsx from "clsx";
import "./cellTable.css";
import { withCompanyGroups } from "../../../shared/containers/containerCompanyGroups";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { dateGridLocalTextOptions } from "../../../shared/services/dataGridLocalTextOptions";

const ControlGroupsTable = (props) => {
  const { companyGroups, selectedGroup, onHandleClick } = props;

  if (companyGroups.length === 0) {
    return null;
  }

  const handleEvent = (e) => {
    onHandleClick(e.row.id);
  };

  const styleSelect = (params) => {
    return clsx("inActive-cell", {
      inActive: selectedGroup !== null && params.id === selectedGroup.id,
    });
  };

  const getColumns = () => {
    return [
      {
        field: "title",
        headerName: "Наименование",
        cellClassName: styleSelect,
        width: 820,
      },
    ];
  };

  const onHandleClickPropagation = (e) => {
    e.stopPropagation();
  };

  return (
    <div className={styles.controlGroupsTableContainer} onClick={onHandleClickPropagation}>
      <DataGrid
        id={"groupsTableId"}
        А
        onRowClick={handleEvent}
        rowHeight={30}
        disableColumnSelector={true}
        disableColumnFilter={true}
        localeText={{
          ...dateGridLocalTextOptions,
          footerRowSelected: (count) => `Cтрок выбранно: ${count}`,
        }}
        rows={getRows(companyGroups)}
        columns={getColumns()}
        sx={{
          "& .MuiDataGrid-row:hover": {
            cursor: "pointer",
          },
        }}
        disableRowSelectionOnClick
      />
    </div>
  );
};

const getRows = (companyGroups) => {
  return companyGroups.map((x) => {
    return {
      ...x,
    };
  });
};

export default withCompanyGroups(React.memo(ControlGroupsTable));
